"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIEmptyState = _interopRequireDefault(require("UIComponents/empty/UIEmptyState"));

var propTypes = {
  noResults: _propTypes.default.bool,
  onResetFilters: _propTypes.default.func
};

function TimelineZeroStateAdvancedFilters(_ref) {
  var noResults = _ref.noResults,
      onResetFilters = _ref.onResetFilters;
  var translationKey = noResults ? 'noSearchResults' : 'noFiltersSelected';

  var button = onResetFilters && _react.default.createElement(_UIButton.default, {
    key: "clear-button",
    use: "tertiary-light",
    onClick: onResetFilters
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "profileContentTimeline.filters.clearFilters"
  }));

  var primaryContent = [_react.default.createElement("p", {
    key: "subtitle"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "profileContentTimeline.zeroState.advancedFilters.description." + translationKey
  })), button];
  return _react.default.createElement(_UIEmptyState.default, {
    reverseOrder: true,
    titleText: _react.default.createElement(_FormattedMessage.default, {
      message: "profileContentTimeline.zeroState.advancedFilters.title." + translationKey
    }),
    primaryContent: primaryContent,
    secondaryContent: _react.default.createElement(_UIIllustration.default, {
      name: "empty-state-charts",
      width: "100%"
    }),
    secondaryContentWidth: 200
  });
}

TimelineZeroStateAdvancedFilters.propTypes = propTypes;
var _default = TimelineZeroStateAdvancedFilters;
exports.default = _default;
module.exports = exports.default;